export default function () {
  return {
    invoices: [],
    isLoadingInvoices: false,
    paymentArrangements: [],
    isLoadingPaymentArrangements: false,
    invoiceAttachmentIdsFetched: [],
    isLoadingAttachments: false,
    isPaymentArrangementsDisabled: false,
    hasUnproccessedPaymentArrangments: false,
  };
}
